(function () {
    'use strict';

    angular
        .module('platformApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('bunny/api/front-users/register', {}, {});
    }
})();
